// @flow

export default {
  headerMobileMaxWidth: 915,
};
